import React, { memo, useCallback, useState, useEffect } from "react";
import GPSelectMultiple from '@gp/components/SelectMultiple';
import GPSelect from '@gp/components/Select';
import DateSelector from "./components/DateSelector";
import { useDebounce } from 'ahooks';
import './index.scss';

interface FilterPropsType {
  loading: boolean;
  dateRange: string;
  onChange: ((
    category: string[],
    dateType: dateTypes,
    date: string[],
  ) => void) | null;
}

const DEFAULT_PROPS: FilterPropsType = {
  loading: true,
  dateRange: '',
  onChange: null,
};

function Filter(props: FilterPropsType) {
  const {
    loading,
    dateRange,
    onChange,
  } = props;

  const [category, setCategory] = useState<string[]>([]);
  const [dateType, setDateType] = useState<dateTypes>('quarter');
  const [date, setDate] = useState<string[]>([]);
  const debounceDate = useDebounce(date, { wait: 50 });

  // 用于是月筛选器时不要输入聚焦
  const handleMonthFocus = useCallback((e) => { e.target.blur() }, []);
  // 用于是年筛选器时不要输入聚焦
  const handleYearFocus = useCallback((e) => { e.target.blur() }, []);

  const categoryHandleChange = useCallback(
    (v: string[]) => {
      // 当前后都是全选时规避重复请求接口
      if ([0, 2]?.includes(category?.length) && [0, 2]?.includes(v?.length)) return;
      setCategory(v);
    },
    [category],
  );

  const dateTypeHandleChange = useCallback(
    (v: dateTypes) => {
      setDateType(v);
      // 解除事件绑定
      const monthEl = document.querySelectorAll('.calendar-filter-date-month-selector .tea-input');
      const yearEl = document.querySelectorAll('.calendar-filter-date-year-selector .tea-input');
      if (monthEl) {
        for (let i = 0;i < monthEl?.length;i ++) {
          const t = monthEl?.[i];
          if (t) {
            t.removeEventListener('focus', handleMonthFocus);
          }
        }
      }
      if (yearEl) {
        for (let i = 0;i < yearEl?.length;i ++) {
          const t = yearEl?.[i];
          if (t) {
            t.removeEventListener('focus', handleYearFocus);
          }
        }
      }
    },
    [],
  );

  const dateHandleChange = useCallback(
    (v: string[], type: dateTypes) => {
      setDate([...v]);
    },
    [],
  );

  // 触发Change
  useEffect(() => {
    if (!Array.isArray(category) || !dateType || !Array.isArray(debounceDate) || !debounceDate?.length) return;
    onChange?.(
      category,
      dateType,
      debounceDate,
    );
  }, [category, debounceDate]);

  return (
    <section className="calendar-filter-content">
      <GPSelectMultiple
        className="calendar-filter-category-selector"
        label="Category"
        disabled={loading || !dateRange}
        options={[
          {
            value: '1',
            text: 'Project Milestone',
            groupKey: 'separated',
          },
          {
            value: '2',
            text: 'Management',
            groupKey: 'separated',
          },
        ]}
        value={category}
        onChange={categoryHandleChange}
      />
      <div className="calendar-filter-date-selector">
        <GPSelect
          className="calendar-filter-date-type-selector"
          style={{width: 100}}
          disabled={loading || !dateRange}
          label=""
          value={dateType}
          options={[
            {
              value: 'month',
              text: 'Month',
            },
            {
              value: 'quarter',
              text: 'Quarter',
            },
            {
              value: 'year',
              text: 'Year',
            },
          ]}
          onChange={dateTypeHandleChange}
        />
        <DateSelector
          loading={loading}
          range={dateRange}
          dateType={dateType}
          monthOnFocus={handleMonthFocus}
          yearOnFocus={handleYearFocus}
          onChange={dateHandleChange}
        />
      </div>
    </section>
  );
}

Filter.defaultProps = DEFAULT_PROPS;

export default memo(Filter);
